<template>
    <ul class="navbar-nav me-auto mb-2 mb-lg-0" >
        <li class="nav-item">
            <router-link class="nav-link" active-class="active" aria-current="page" to="/">Dashboard</router-link>
        </li>
        <li class="nav-item"  v-if="auth.check([TipoUsuario.ADMIN, TipoUsuario.MASTER])" >
            <router-link class="nav-link" active-class="active" aria-current="page" to="/lojas">Lojas</router-link>
        </li>
        <li class="nav-item"  v-if="auth.check([TipoUsuario.ADMIN, TipoUsuario.MASTER])" >
            <router-link class="nav-link" active-class="active" aria-current="page"
                to="/usuarios">Usuários</router-link>
        </li>
        <li class="nav-item" >
            <router-link class="nav-link" active-class="active" aria-current="page"
                to="/recebimento-mercadorias">Recebimento de Mercadorias</router-link>
        </li>

    </ul>
</template>
<script setup lang="ts">
import { useAuth } from '@/plugins/auth';
import { TipoUsuario } from '@/store/usuarios';


const auth = useAuth()


</script>